export default "__VITE_ASSET__BXG6n7OM__"